<div
  class="wizard-step-circle"
  [class.active]="status === radioStates.Active"
  [class.completed]="status === radioStates.Completed"
>
  <div class="wizard-step-circle-inner">
    <ion-icon name="checkmark"></ion-icon>
  </div>
</div>
